// extracted by mini-css-extract-plugin
export default {"container":"testimonies_container__fZ+ml","content_wrapper":"testimonies_content_wrapper__q34AB","quote_list":"testimonies_quote_list__0xD-K"};